import { render, staticRenderFns } from "./PortalAccessInvitation.vue?vue&type=template&id=53bb9165"
import script from "./PortalAccessInvitation.vue?vue&type=script&lang=js"
export * from "./PortalAccessInvitation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports